export default {
  rolId: (state,data) => state.rolId = data,
  com_id: (state,data) => state.com_id = data,
  name: (state,data) => state.name = data,
  guard_name: (state,data) => state.guard_name = data,
  rol_status: (state,data) => state.rol_status = data,
  rols: (state,data) => state.rols = data,
  trash_rol(state){
    state.rolId=0;
    state.com_id=0;
    state.name='';
    state.guard_name='';
    state.rol_status='';
    state.rols=null;
  }
}
